<div class="c-modal c-modal--sm">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-card c-card--height-fit" style="box-shadow:none;">
			<div class="c-modal__content">
				<div class="o-grid">
					<div class="o-grid__cell u-no-p">
	                    <p class="c-modal__title c-text c-text--xl">{{ 'Modal.Title.Switch_Role_Title' | translate }}</p>
	                </div>
				</div>
				<br>
				<p class="c-text u-osb-md">{{ 'Modal.Content.Switch_Role_To_Patient' | translate }}</p>
				<form name="vm.form" [formGroup]="consentForm" class="c-form u-ost-xl">
					<div class="u-ost-md u-osb-lg">
						<div class="c-form__group u-osb-sm" [ngClass]="{'c-form__group--error': consentForm.get('consent1').touched && consentForm.get('consent1').invalid }">
							<label class="c-checkbox">
								<input id="consent1" type="checkbox" formControlName="consent1" name="consent1" required>
								<span id="consent1Label" [innerHTML]="vm.tosConsent"></span>
							</label>
						</div>
						<div class="c-form__group u-osb-sm" [ngClass]="{'c-form__group--error': consentForm.get('consent2').touched && consentForm.get('consent2').invalid }">
							<label class="c-checkbox">
								<input id="consent2" type="checkbox" formControlName="consent2" name="consent2" required>
								<span id="consent2Label" [innerHTML]="vm.ppConsent"></span>
							</label>
						</div>
					</div>
				</form>
				<div class="o-grid">
					<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-50 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-pl">
						<button id="closeButton" class="c-button c-button--s6 c-button--fit c-button--narrow" (click)="vm.handleModalClose()" [disabled]="vm.processing">{{ 'Common.No' | translate }}</button>
					</div>
					<div class="o-grid__cell o-grid__cell--slim o-grid__cell--w-50 o-grid__cell--w-fixed@md-and-up u-no-pr">
						<button id="submitButton" class="c-button c-button--s1 c-button--fit c-button--narrow" (click)="vm.handleModalSubmit()" [disabled]="vm.processing">{{ 'Common.Yes' | translate }}</button>
					</div>
				</div>
				<loader-overlay *ngIf="vm.processing"></loader-overlay>
			</div>
		</div>
	</div>
</div>
